module.exports = __webpack_public_path__ + "static/img/upi.5af8c84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/upi.png
// module id = mNW/
// module chunks = 1